import React from "react";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";


function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
}

export function isMobileDevice() {
    return window.innerWidth < 768;
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function getTs() {
    return (new Date()).getTime()
}

export function timePassed(flag) {
    return (getTs() - flag) / 1000
}

export function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        console.log('Async: Copying to clipboard was successful!');
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
    });
}

class Utils {
    static setPageTitle(title) {
        document.title = `${title} — Стоматологическая клиника «ЭСТЭЙ»`
    }

    static titleString(string) {
        let result = string.charAt(0).toUpperCase() + string.slice(1)
        return result.replace('_', ' ');
    }

    static condition(conditionExp, elementsTrue, elementFalse) {
        let elements = elementsTrue.map(element => element)
        return conditionExp ? <>{elements}</> : elementFalse
    }

    static listToDict(array, key) {
        let newDict = {}
        array.forEach(item => {
            newDict[item[key]] = item
        })
        return newDict
    }

    static arrayHas(array, key) {
        return array.indexOf(key) >= 0
    }
}

function rangeList(n) {
    return Array(n).fill(0).map((_, i) => i)
}

function descendingComparator(a, b, orderBy) {
    if (orderBy === 'craneNumber') {
        if (a[orderBy] === undefined) {
            return -9999;
        }
        if (b[orderBy] === undefined) {
            return 9999;
        }
    }
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    if (orderBy === 'gpt_score') orderBy = 'gpt_score_compare'

    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const safetyInput = (value) => {
    return ((value !== null) && (typeof value !== 'undefined')) ? value : ""
}

const safetyName = (user) => {
    return `${user.first_name ? user.first_name : ''} ${user.last_name ? user.last_name : ''}`
}

const safetyExternalUrl = (url) => {
    if (url) {
        return url.startsWith('http://') || url.startsWith('https://')
            ? url
            : `https://${url}`;
    }
}

const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
};

const formatBigNumber = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

const formatPrice = (number) => {
    return `${formatBigNumber(number)} ₽`;
};


const withRouterHOC = (WrappedComponent) => (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    return <WrappedComponent
        {...props}
        location={location}
        navigate={navigate}
        params={params}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
    />;
};

export {
    safetyInput,
    safetyName,
    safetyExternalUrl,
    descendingComparator,
    getComparator,
    stableSort,
    rangeList,
    withRouterHOC,
    formatDate,
    formatBigNumber,
    formatPrice
};
export default Utils